import { Group } from "@mui/icons-material";
import React from "react";

import { useHistoryNavigate } from "../../../../../../../../hooks/useHistoryNavigate";
import CaseListToolTip from "../ui/CaseListToolTip";
import indicatorColors from "../utils/indicatorColors";

const RelatedCases = ({ relatedCases }) => {
  const { historyNavigate } = useHistoryNavigate();

  const navigateToDetail = (caseId) => {
    historyNavigate("client-detail", caseId);
  };

  return (
    <div id="Do-Not-Contact" data-test-id="Do-Not-Contact">
      <span style={{ color: indicatorColors.green }}>
        <CaseListToolTip
          caseList={relatedCases}
          headerTitle={"Related Cases"}
          navigateToCaseDetail={navigateToDetail}
        >
          <Group fontSize="inherit" />
        </CaseListToolTip>
      </span>
    </div>
  );
};
export default RelatedCases;
